// extracted by mini-css-extract-plugin
module.exports = {"topVignetteProducts":"appPill_topVignetteProducts__Y1J5o","productTopText":"appPill_productTopText__ufEd5"};